// 由 EB view/admin/src/router/modules/station.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const stationRouter: RouteRecordRaw =
  {
    path: `${roterPre}/station`,
    name: 'station',
    meta: {
      icon: '',
      title: '公告列表'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'notice',
        name: 'stationNotice',
        meta: {
          title: '公告列表'
        },
        component: () => import('@/views/station/notice/index.vue')
      },
      {
        path: "notice/detail/:id?",
        name: "stationNoticeDetail",
        meta: {
          title: "发布公告",
          activeMenu: '/station/notice',
        },
        component: () => import('@/views/station/notice/detail.vue')
      }
    ]
  }
export default stationRouter;
